import mixx from '../../../../mixin/mixin.js'

export default {
  mixins: [mixx],
  name: 'facturas',

  data() {
    return {
      loading: false,
      cabal: { userr: "", pass: "" },
      inptType: "password",
    }
  },


  mounted: function () {
    window.comp1 = this
    $('.box').boxWidget()
    this.cabalInfo();
  },
  methods: {
    cabalInfo() {
      this.cabal = { userr: "", pass: "" };
      this.loading = true;
      let dis = this;
      this.$http
        .get(
          "/config/user/accesos/cabal/",
        )
        .then(res => {
          this.cabal = res.data; 
        }).catch(() => {
          alert('Información no disponible')
        }).finally(function () {
          dis.loading = false;
        });
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/fs/infoCabal/main/index.js